/**
 * @generated SignedSource<<b4d9b389974e1e2b04f360a57f72927b>>
 * @relayHash 149d2389147c874aab96bf7e444616a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9f1a2541961493f1ece64ec09a3d9b2e21ae4af470894d68a879429dad460c9

import type { ConcreteRequest } from 'relay-runtime';
export type useStudioPermissionsWorkspaceCapabilitiesQuery$variables = {
  workspaceId: string;
};
export type useStudioPermissionsWorkspaceCapabilitiesQuery$data = {
  readonly studio_workspaceCapabilities: {
    readonly canCreateAutomationsInDefaultSpace: boolean | null;
  } | null;
};
export type useStudioPermissionsWorkspaceCapabilitiesQuery = {
  response: useStudioPermissionsWorkspaceCapabilitiesQuery$data;
  variables: useStudioPermissionsWorkspaceCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "workspaceId",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "StudioWorkspaceCapabilities",
    "kind": "LinkedField",
    "name": "studio_workspaceCapabilities",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "canCreateAutomationsInDefaultSpace"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useStudioPermissionsWorkspaceCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStudioPermissionsWorkspaceCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "149d2389147c874aab96bf7e444616a0",
    "id": "b9f1a2541961493f1ece64ec09a3d9b2e21ae4af470894d68a879429dad460c9",
    "metadata": {},
    "name": "useStudioPermissionsWorkspaceCapabilitiesQuery",
    "operationKind": "query",
    "text": "query useStudioPermissionsWorkspaceCapabilitiesQuery($workspaceId:ID!){studio_workspaceCapabilities(workspaceId:$workspaceId)@optIn(to:\"StudioWorkspaceCapabilities\"){canCreateAutomationsInDefaultSpace}}"
  }
};
})();

(node as any).hash = "1a9a593d1bbf9038222f298a6b387b82";

export default node;
